export enum TextMessageScheduleFrequency {
  ONCE = 'once',
  ONCE_DAY = 'once_a_day',
  ONCE_WEEK = 'once_a_week',
  ONCE_MONTH = 'once_a_month',
}
